




import { Component, Vue, Prop, Watch } from "vue-property-decorator";

// Declara window.markdownit para TypeScript
declare global {
  interface Window {
    markdownit: any; // O el tipo más específico si tienes la definición global
  }
}

@Component
export default class MarkdownRenderer extends Vue {
  @Prop({ required: true }) readonly markdownContent!: string;

  private md: any | null = null; // Usar 'any' o el tipo global de MarkdownIt si lo tienes
  public renderedMarkdown: string = "";

  created() {
    // Asegurarse de que markdownit esté disponible globalmente
    if (window.markdownit) {
      this.md = new window.markdownit();
      console.log("md",this.md);
    } else {
      console.error(
        "MarkdownIt no está disponible. Asegúrate de que la CDN esté cargada."
      );
    }
  }

  mounted() {
    console.log("markdownContent"+this.markdownContent);
    if (this.md && this.markdownContent) {
      this.renderedMarkdown = this.md.render(this.markdownContent);
    } else {
      this.renderedMarkdown = this.markdownContent; // Fallback si no se puede renderizar
    }
  }

  @Watch("markdownContent")
  onMarkdownContentChanged() {
    console.log("markdownContent"+this.markdownContent);
    if (this.md && this.markdownContent) {
      this.renderedMarkdown = this.md.render(this.markdownContent);
    } else {
      this.renderedMarkdown = this.markdownContent; // Fallback si no se puede renderizar
    }
  }

  public render() {
    console.log("markdownContent"+this.markdownContent);
    if (this.md && this.markdownContent) {
      this.renderedMarkdown = this.md.render(this.markdownContent);
    } else {
      this.renderedMarkdown = this.markdownContent; // Fallback si no se puede renderizar
    }
  }
}
